export default {
  'zh': {
    'days': ['日', '一', '二', '三', '四', '五', '六'],
    'months': ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
    'pickers': ['未来7天', '未来30天', '最近7天', '最近30天'],
    'placeholder': {
      'date': '请选择日期',
      'dateRange': '请选择日期范围'
    }
  },
  'en': {
    'days': ['SU', 'MO', 'TU', 'WE', 'TH', 'FR', 'SA'],
    'months': ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    'pickers': ['next 7 days', 'next 30 days', 'previous 7 days', 'previous 30 days'],
    'placeholder': {
      'date': 'Select Date',
      'dateRange': 'Select Date Range'
    }
  },
  'fr': {
    'days': ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
    'months': ['Jan', 'Fev', 'Mar', 'Avr', 'Mai', 'Juin', 'Juil', 'Aout', 'Sep', 'Oct', 'Nov', 'Dec'],
    'pickers': ['7 jours suivants', '30 jours suivants', '7 jours précédents', '30 jours précédents'],
    'placeholder': {
      'date': 'Sélectionnez une date',
      'dateRange': 'Sélectionnez une période'
    }
  },
  'es': {
    'days': ['Dom', 'Lun', 'mar', 'Mie', 'Jue', 'Vie', 'Sab'],
    'months': ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
    'pickers': ['próximos 7 días', 'próximos 30 días', '7 dás anteriores', '30 das anteriores'],
    'placeholder': {
      'date': 'Seleccionar fecha',
      'dateRange': 'Seleccionar un rango de fechas'
    }
  },
  'pt-br': {
    'days': ['Dom', 'Seg', 'Ter', 'Qua', 'Quin', 'Sex', 'Sáb'],
    'months': ['Jan', 'Fev', 'Mar', 'Abr', 'Maio', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
    'pickers': ['próximos 7 dias', 'próximos 30 dias', '7 dias anteriores', ' 30 dias anteriores'],
    'placeholder': {
      'date': 'Selecione uma data',
      'dateRange': 'Selecione um período'
    }
  },
  'ru': {
    'days': ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
    'months': ['Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн', 'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'],
    'pickers': ['след. 7 дней', 'след. 30 дней', 'прош. 7 дней', 'прош. 30 дней'],
    'placeholder': {
      'date': 'Выберите дату',
      'dateRange': 'Выберите период'
    }
  },
  'de': {
    'days': ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
    'months': ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
    'pickers': ['nächsten 7 Tage', 'nächsten 30 Tage', 'vorigen 7 Tage', 'vorigen 30 Tage'],
    'placeholder': {
      'date': 'Datum auswählen',
      'dateRange': 'Zeitraum auswählen'
    }
  },
  'it': {
    'days': ['Dom', 'Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab'],
    'months': ['Gen', 'Feb', 'Mar', 'Apr', 'Mag', 'Giu', 'Lug', 'Ago', 'Set', 'Ott', 'Nov', 'Dic'],
    'pickers': ['successivi 7 giorni', 'successivi 30 giorni', 'precedenti 7 giorni', 'precedenti 30 giorni'],
    'placeholder': {
      'date': 'Seleziona una data',
      'dateRange': 'Seleziona un intervallo date'
    }
  },
  'cs': {
    'days': ['Ned', 'Pon', 'Úte', 'Stř', 'Čtv', 'Pát', 'Sob'],
    'months': ['Led', 'Úno', 'Bře', 'Dub', 'Kvě', 'Čer', 'Čerc', 'Srp', 'Zář', 'Říj', 'Lis', 'Pro'],
    'pickers': ['příštích 7 dní', 'příštích 30 dní', 'předchozích 7 dní', 'předchozích 30 dní'],
    'placeholder': {
      'date': 'Vyberte datum',
      'dateRange': 'Vyberte časové rozmezí'
    }
  }
}



// WEBPACK FOOTER //
// ./src/core/components/edDatepicker/languages.js